import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { fetchData as fetchDataNode } from "../nodeApi/fetchData";
import { fetchData } from "./UseStudentGetApi";

export const useZoneList = (filter) => {
    return useQuery({
        queryKey: ["collab-zones", filter],
        queryFn: () => fetchDataNode(`collab-zones`, filter),
        enabled: !!filter?.city_id,
    });
};

export const useZoneviseApartment = (filter) => {
    return useQuery({
        queryKey: ["apartment-crm", filter],
        queryFn: () => fetchDataNode(`apartment-crm`, filter),
        enabled:!!filter?.user_id
        
    });
};

export const useCityviseApartment = (filter) => {
    return useQuery({
        queryKey: ["apartments/by-cityorzone", filter],
        queryFn: () => fetchDataNode(`apartments/by-cityorzone`, filter),
    });
};
export const useOnbordApartment = (filter) => {
    return useQuery({
        queryKey: ["apartments/by-on-boarded-cityorzone", filter],
        queryFn: () => fetchDataNode(`apartments/by-on-boarded-cityorzone`, filter),
    });
};
export const useApartmentListClusterId = (filter) => {
    return useQuery({
        queryKey: ["apartments/by-coordinator", filter],
        queryFn: () => fetchDataNode(`apartments/by-coordinator`, filter),
    });
};
export const useApartmentFacility = () => {
    return useQuery({
        queryKey: ["apartment-facilities"],
        queryFn: () => fetchDataNode(`apartment-facilities`),
    });
};




export const TermAndConditionList = (filter) => {
    return useQuery({
        queryKey: ["apartment-terms/by-apartment", filter],
        queryFn: () => fetchDataNode(`apartment-terms/by-apartment`, filter),
        enabled:!!filter?.apartment_id
    });
};



export const ApartmentListonBasisContactPerson = () => {
    return useInfiniteQuery({
        queryKey: ["collab-apartment-details-list"],
        queryFn: async ({ pageParam = 1 }) => {
            const data = await fetchDataNode(`collab-apartment-details-list?page=${pageParam}`);
            return data?.data
        },
        getNextPageParam: (lastPage) => {
            return lastPage.current_page < lastPage.last_page ? lastPage.current_page + 1 : undefined;
        }
    });
};



export const useAllZoneList = (filter) => {
    return useQuery({
        queryKey: ["zones",filter],
        queryFn: () => fetchDataNode(`zones`,filter),
    });
};
